import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Top from '../Top/Top';
import Breadcrumbs from './Breadcrumbs';
import ProductItem from './ProductItem';
import TemplateParser from '../Templates/TemplateParser';
import Filter from '../../hocs/Filter/Filter';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { resetFilter } from '../../actions/environment';
import { origin } from '../../config';
import { prefix } from '../../utils/locale';
import s from './Category.scss';

const Category = ({ data, currentPath, setup, productCache, filter, pageType, ...props }) => {
	const cache = productCache?.[setup.market]?.[setup.pricelist];
	if (!data || !cache || pageType !== 'category') return null;
	const parts = data?.parts || [];
	const contentSections = [];
	const collectionSections = {};
	const bottomSections = [];
	const isFiltered = filter.filteredBy.filter((f) => {
		if (Object.keys(f)[0] === 'outdoor' && currentPath.indexOf('outdoor-furniture') !== -1) return false;
		if (Object.keys(f)[0] === 'collections') return false;
		return Object.keys(f)[0] !== 'categories';
	}).length > 0 || filter.sort !== '';
	let topSections = 0;

	data.content.linkCanonical = `${origin}${prefix(setup, currentPath)}`;

	if (!isFiltered) {
		parts.forEach((section) => {
			const insertPosition = section?.partsMeta?.priority || 0;
			const collectionPosition = section?.partsMeta?.collection || false;

			if (collectionPosition) {
				if (!collectionSections[collectionPosition]) collectionSections[collectionPosition] = [];
				if (collectionSections[collectionPosition][insertPosition]) {
					collectionSections[collectionPosition][collectionSections[collectionPosition].length] = section;
				} else {
					collectionSections[collectionPosition][insertPosition] = section;
				}
			} else if (parseInt(insertPosition, 10) < 0) {
				if (bottomSections[Math.abs(insertPosition)]) {
					bottomSections[bottomSections.length] = section;
				} else {
					bottomSections[Math.abs(insertPosition)] = section;
				}
			} else if (contentSections[insertPosition]) {
				contentSections[contentSections.length] = section;
			} else {
				contentSections[insertPosition] = section;
			}
		});
	}

	const isLocalized = cache.localized[setup.language];
	const categoryTitles = isLocalized ? Object.keys(cache.filterArrays.categories).reduce((acc, cat) => {
		const categoryKey = isLocalized.categories[cat] ? isLocalized.categories[cat].key : cat;
		const categoryDescription = isLocalized.categories[cat] ? isLocalized.categories[cat].description : cache.filterDescriptions.categories[cat];
		return ({ ...acc, [categoryKey]: categoryDescription });
	}, {}) : cache.filterDescriptions.categories;
	const categoryTitle = categoryTitles[currentPath];

	const topSectionsContent = contentSections.map((section, i) => {
		if (section === undefined || i > topSections || !section?.partsMeta?.display || section.partsMeta.display !== 'block') return null;
		topSections += 1;
		return <TemplateParser key={i} sections={section.sections} setup={setup} />;
	});

	return (
		<main role="main" className={s.category}>
			<Top setup={setup} pageContent={data.content} paths={data.paths} />
			<Breadcrumbs currentPath={currentPath} filter={filter} filtering={cache} data={data} setup={setup} resetFilter={props.resetFilter} />
			{
				topSectionsContent.length > 0 && <div className={s.category_topCMS}>{ topSectionsContent }</div>
			}
			<ErrorBoundary message="Filter:" debugData={cache}>
				<Filter ListComponent={ProductItem} filter={filter} filtering={cache} data={data} setup={setup} currentPath={currentPath} currentView={categoryTitle} collectionSections={collectionSections} contentSections={contentSections.slice(topSections)} />
			</ErrorBoundary>
			<div className={s.category_topCMS}>
				{
					bottomSections.map((section, i) => {
						if (section === undefined) return null;
						return <TemplateParser key={i} sections={section.sections} setup={setup} />;
					})
				}
			</div>
		</main>
	);
};

const mapState = ({ environment, productCache, filter }, { data, currentPath }) => ({
	data,
	currentPath,
	setup: environment.setup,
	productCache,
	filter,
});

export default hot(module)(connect(mapState, { resetFilter })(Category));
